define('widgets/inputs/AbstractInputWidget',['underscore'], function (_) {

    /**
     * Use this for shared functionality between inputs.
     *
     * Considered making this a set of mixins but it didn't seem necessary yet.
     */
    function AbstractInputWidget() {
        this.subscriptions = [];
    }

    AbstractInputWidget.prototype.INTERACTING_INTERVAL = 350;

    AbstractInputWidget.prototype.activate = function(settings) {

        var timeout,
            timeoutForIsShowingErrors;

        this.field = settings.field;
        this.label = settings.label;
        this.lowerLabel = settings.lowerLabel;

        this.attr = _.extend({}, this.field.attr, settings.attr);

        this.autoFocus = !!settings.autoFocus;
        this.subscriptions.push(this.field.value.subscribe(function() {

            this.field.isInteracting(true);

            window.clearTimeout(timeout);

            timeout = window.setTimeout(function() {
                this.field.isInteracting(false);
            }.bind(this), this.INTERACTING_INTERVAL);

        }.bind(this)));

        this.subscriptions.push(this.field.isInteracting.subscribe(function(isInteracting) {

            if (!isInteracting) {

                this.field.isShowingErrors(false);

                window.clearTimeout(timeoutForIsShowingErrors);

                timeoutForIsShowingErrors = window.setTimeout(function() {
                    this.field.isShowingErrors(true);
                }.bind(this), 1900);
            }

        }.bind(this)));
    };

    AbstractInputWidget.prototype.detached = function() {

        this.subscriptions.forEach(function(subscription) {
            subscription.dispose();
        });

        this.subscriptions = [];
    };

    AbstractInputWidget.prototype.compositionComplete = function() {

        if (this.autoFocus) {
            this.field.isFocused(true);
        }

    };

    return AbstractInputWidget;

});

